import { render, staticRenderFns } from "./DoctorNoteForm.vue?vue&type=template&id=19f79964&scoped=true&"
import script from "./DoctorNoteForm.vue?vue&type=script&lang=js&"
export * from "./DoctorNoteForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f79964",
  null
  
)

export default component.exports